import React, {Component} from 'react';
import InfoCtrl from './info';
import { translate, Trans } from "react-i18next";
class Welcome extends Component {
render(){
    return(
        <div>            
            <div className="row">
                <div className="col-xs-12 block">
                    <div className="thumbnail thumbnailContent alt">
                        <h3 className="color-1"><Trans>Welcome</Trans></h3>
                        <p><Trans>This is</Trans> {<strong>{this.props.schoolInfo.name}</strong>} <Trans>electronic application for free and reduced priced meals for USDA's National School Lunch & School Breakfast Programs</Trans>.</p>
                        <p><Trans>This interactive application will guide you through the application process</Trans>. <Trans>When you are ready to apply, click the 'Get started' button below to begin</Trans>.</p>
                    </div>
                </div>
            </div>
            {
                (this.props.schoolInfo.schoolPdfUrl||'')!=''?
                <div className="row">
                    <div className="col-md-12">
                        <InfoCtrl fileUrl={this.props.schoolInfo.schoolPdfUrl} />
                    </div>
            </div>:null
            }            
            <div className="row">
                <div className="col-xs-12">
                        <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{
                        this.props.jumpToStep(1)
                    }}><Trans>Get started</Trans>
                    </button>
                </div>
            </div>
        </div>
    )
}
}
export default Welcome;


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/welcome.jsx